import { Directive, OnInit, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[usd-only]'
})

// diretriz para a formatação do campo de pesquisa do produto
export class UsdOnlyDirective implements OnInit {
  stringChars = new RegExp(/[\.\\\/$&?`´"';#]/g, '');

  constructor(public el: ElementRef, public renderer: Renderer2) {}

  ngOnInit() {
    this.format(this.el.nativeElement.value); // format any initial values
  }

  @HostListener('input', ["$event.target.value"]) onInput(e: string) {
    this.format(e);
  };

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault(); 
    this.format(event.clipboardData.getData('text/plain'));
  }

  format(val:string) {
    // Formata a pesquisa do usuário   
    const search = String(val).replace(this.stringChars, '');
    this.renderer.setProperty(this.el.nativeElement, 'value', search);
  }

}
